<template>
  <div>
    <div class="slogan">
			<p class="slogan__text [ text-light text-center ] [ p-3 mb-0 ]">
				Vuoi essere sicuro di non perdere un evento?
				<span class="d-block">Prenotalo subito online!</span>
			</p>
    </div>

		<div class="row [ mx-0 ] [ justify-content-center ]">
			<div v-for="(tag,i) in tags" :key="i" class="col-12 col-lg-4 [ px-0 ]">
				<router-link tag="div" :to="'/eventi/'+tag.Codice" class="row [ mx-0 ] [ is-link ]">
					<div class="col-5" :class="i%2==0?'order-1 order-lg-1':'order-2 order-lg-1'">
						<h1 class="title">
							{{tag.Descrizione}}
							<app-category :color="tag.Colore"></app-category>
						</h1>
					</div>
					<div class="col-7 [ background-cat ]" :class="'background-cat--'+tag.Codice+(i%2==0?' order-2 order-lg-1':' order-1 order-lg-2')">
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { mapActions } from 'vuex'

moment.locale('it')

export default {
  components: {

  },
  mounted () {
    // var me = this
    // console.log("params", this.$route.params)
    // this.$store.dispatch('event/events', { tag: me.$route.params.tag || 'all', q: '', start: '', end: '' });

  },
  computed: {
    tags () {
      return this.$store.state.event.tags
    },
    query () {
      return this.$route.query.q
    }
  },
  methods: {

  },
  // beforeRouteUpdate(to, from, next) {

  //  var me = this
  //  // react to route changes...
  //  this.$store.dispatch('event/clearEvents');
  //  // don't forget to call next()
  //  next();
  // },
  created () {
    // var me = this

    // this.$store.dispatch('event/tags').then(response => {
    //  this.$store.dispatch('event/events', { tag: me.$route.params.tag || 'all', q: me.$route.query.q || '', start: '', end: '' });
    // })
  }

}
</script>
